import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createProtocolFailed,
  createProtocolRequested,
  createProtocolSucceeded,
  deleteProtocolFailed,
  deleteProtocolRequested,
  deleteProtocolSucceeded,
  updateProtocolFailed,
  updateProtocolRequested,
  updateProtocolSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createProtocolRequest(data) {
  yield put(createProtocolRequested(data));

  try {
    const { item } = yield call(request, api.createProtocol, data);

    const action = createProtocolSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createProtocolFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateProtocolRequest(id, data) {
  yield put(updateProtocolRequested(id, data));

  try {
    const { item } = yield call(request, api.updateProtocol, id, data);

    const action = updateProtocolSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateProtocolFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteProtocolRequest(id) {
  yield put(deleteProtocolRequested(id));

  try {
    const { item } = yield call(request, api.deleteProtocol, id);

    const action = deleteProtocolSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteProtocolFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
